import { render, staticRenderFns } from "./RTshop.vue?vue&type=template&id=3a755d5d&scoped=true&"
import script from "./RTshop.vue?vue&type=script&lang=js&"
export * from "./RTshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a755d5d",
  null
  
)

export default component.exports